import React from 'react';
import { motion } from "framer-motion";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { HashLink } from 'react-router-hash-link';

const Intro = () => {
    return (
        <div className="hero" id='about'>
            <div className="overflow-hidden mx-6 sm:mx-12 lg:mx-24 mt-8 lg:mt-14 p-4 md:p-8 lg:p-12 h-full">
                <div id="about" className="flex flex-col-reverse lg:flex-row items-center lg:items-start lg:mx-4 lg:my-28 py-8 lg:py-18 justify-center text-center lg:text-left">
                    {/* About Me Content */}
                    <div className="lg:w-1/2 lg:pr-8">
                        <motion.h1 
                            className=" text-2xl md:text-3xl font-bold text-[#b54a73]" 
                            initial={{ opacity: 0, y: 50 }} 
                            animate={{ opacity: 1, y: 0 }} 
                            transition={{ duration: 2.5 }}
                            data-aos="fade-up" 
                            data-aos-delay="300"
                        >
                            👩 ABOUT ME
                        </motion.h1>
                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 2.5, delay: 0.5 }}
                        >
                            <p className="my-10 lg:my-12 text-lg font-semibold mb-5 text-gray-500">
                                Graduated from <span className="text-[#b54a73]">Aksum University</span> 
                                with a CGPA of 3.07, earning a Bachelor of Science in Electrical and Computer Engineering.
                                I am highly interested in coding and began my journey with online courses and self-practice. 
                                I achieved my first goal by being hired as a frontend website developer and Scrum Master at 
                                <span className="text-[#b54a73]"> Brana Software Solutions</span>. Beyond coding, I manage agile methodologies for the programming team, facilitate meetings, and address obstacles. 
                                Additionally, I contribute to the quality assurance team by analyzing UI/UX to improve organizational efficiency and user experiences.
                            </p>
                        </motion.div>
                        <div className="mb-4 md:mb-8">
                            <HashLink
                                className="text-white bg-[#e4a6bd] hover:bg-[#b54a73] inline-flex items-center justify-center w-full px-6 py-3 text-lg shadow-xl rounded-2xl sm:w-auto transition duration-300 ease-in-out transform hover:scale-105"
                                smooth
                                to="/#contact"
                            >
                                Get in touch
                                <svg className="w-4 h-4 ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                                </svg>
                            </HashLink>
                        </div>
                    </div>

                    {/* Lottie Animation */}
                    <div className="lg:w-1/2 flex justify-center lg:justify-end mb-8 lg:mb-0">
                        <DotLottieReact
                            src="https://lottie.host/6eacb645-7b92-4db9-8fd7-74d782378061/iEHLmr4Luq.lottie"
                            loop
                            autoplay
                            className="w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96"
                            data-aos="fade-up"
                            data-aos-delay="700"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Intro;
